// extracted by mini-css-extract-plugin
export default {"progressWrapper":"progressBar_progressWrapper__ThXcC","progressBar":"progressBar_progressBar__EIrBw","progress":"progressBar_progress__k2Egg","size":"progressBar_size__um6cC"};